import React from 'react';
import {withStyles} from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import {BlueButton, GreenButton, GreyButton, OrangeButton} from "../common/ButtonsConstants";
import {
    AddCircleOutlineTwoTone,
    AddCircleTwoTone,
    HighlightOffTwoTone,
    SystemUpdateAltTwoTone
} from "@material-ui/icons";
import TableComponent from "../common/TableComponent";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import TextField from "@material-ui/core/TextField";
import {NotificationContainer, NotificationManager} from "react-notifications";
import moment from "moment";
import {addMsdsRevision, deleteMsds, msds, msdsRevision, saveOrUpdateMsds} from "../../util/MsdsApiUtils";
import {uploadFile, downloadFile, exportReport} from "../../util/ApiUtils";
import {Spinner} from "../common/Spinner";
import {
    addEmergencyResponseTestingRevision,
    emergencyResponseTestingRevision
} from "../../util/OperationModuleApiUtils";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";
import Modal from "@material-ui/core/Modal";
import CommonRevisionModal from "../common/CommonRevisionModal";
import * as CommonUtils from "../../util/CommonUtils";
import { t } from '../../i18n';

const classes = (() => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
}));

const columns = [
    {
        title: 'id',
        field: 'id',
        type: "numeric",
        hidden: true,
    },
    {
        name: t('operation.msds.columns.title'),
        id: 'title',
        type: "text",
    },
    {
        name: t('operation.msds.columns.expiryDate'),
        id: 'expiryDisplayDate',
        type: "text",
    },
    {
        name: t('operation.msds.columns.attachment'),
        id: 'fileName',
        type: "file",
    },
];

class Msds extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            id: null,
            latestRevision: {},
            msdsRecords: [],
            title: '',
            expiryDate: null,
            file: null,
            fileName: "",
            fileId: null,
            isLoading: true,
        };
        this.loadMsdsRecords = this.loadMsdsRecords.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onEdit = this.onEdit.bind(this);
        this.onClear = this.onClear.bind(this);
        this.onFileSelect = this.onFileSelect.bind(this);
        this.export = this.export.bind(this);
        this.loadMsdsRevision = this.loadMsdsRevision.bind(this);
        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.addRevision = this.addRevision.bind(this);
        this.myRef = React.createRef()
    }


    showModal() {
        this.setState({
            show: true
        });
    }

    closeModal(updatedRevision) {
        console.log("updatedRevision");
        console.log(updatedRevision);
        if (updatedRevision) {
            this.setState({
                show: false,
                latestRevision: updatedRevision,
            });
        } else {
            this.setState({
                show: false,
            });
        }
    }

    componentDidMount() {
        this.loadMsdsRecords();
        this.loadMsdsRevision();
    }

    addRevision(request) {
        addMsdsRevision(request)
            .then(response => {
                NotificationManager.success(t('app.notifications.success'), t('messages.revisionUpdated'), 5000);
                console.log('response');
                console.log(response);
                this.closeModal(response);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
        });
    }

    loadMsdsRevision() {
        msdsRevision()
            .then(response => {
                console.log('msds revision', response);
                this.setState({
                    latestRevision: response,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    onDateChange(event, date) {
        console.log(event); //null
        console.log('date', date); //whatever the date the user picked
        this.setState({
            expiryDate: moment(date, "DD/MM/YYYY"),
        });
    }

    onChange({ target }) {
        this.setState({
            ...this.state, [target.name]: target.value
        });
    }

    loadMsdsRecords() {
        msds()
            .then(response => {
                console.log('all msds records', response);
                this.setState({
                    msdsRecords: response,
                    isLoading: false,
                });
            });
    }

    onClear() {
        this.setState({
            id: null,
            title: "",
            file: null,
            expiryDate: null,
            fileName: "",
            fileId: null,
        });
    }

    onSave() {
        console.log("submitting...");
        const msdsRecord = { id: this.state.id, title: this.state.title, expiryDate: this.state.expiryDate };
        saveOrUpdateMsds(msdsRecord)
            .then((msds) => {
                this.setState({
                    isLoading: true,
                });
                if (this.state.file) {
                    const callback = (status, res) => {
                        console.log("result " + status);
                        console.log("result " + res);
                        if (status === 200) {
                            this.loadMsdsRecords();
                            NotificationManager.success(t('app.notifications.success'), t('messages.msdsUploaded'), 5000);
                        } else {
                            console.log(res);
                            NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
                        }
                    };
                    uploadFile("/msds/fileUpload", msds.id, this.state.file, callback);
                } else {
                    this.loadMsdsRecords();
                }
                this.setState({
                    id: null,
                    title: "",
                    file: null,
                    expiryDate: null,
                    fileName: "",
                    fileId: null,
                });
            })
            .catch(error => {
                console.log("error");
                console.log(error);
                NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
            });
    }

    onDelete(record) {
        console.log(record);
        deleteMsds(record)
            .then(() => {
                NotificationManager.success(t('app.notifications.success'), t('messages.msdsRemoved'), 5000);
            }).catch(error => {
                NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
        });
    }

    onEdit(msds) {
        window.scrollTo(0, 0);
        this.setState({
            id: msds.id,
            expiryDate: msds.expiryDate,
            title: msds.title,
            fileName: msds.fileName,
            fileId: msds.fileId,
        });
    }

    export() {
        exportReport('/msds/export');
    }

    onFileSelect = (event) => {
        let file = event.target.files[0];
        console.log("file", file);
        this.setState({
            file: file
        });
    };

    render() {
        let { state } = this;
        if (state.isLoading) {
            return <Spinner/>;
        }
        console.log("state.msdsRecords", state.msdsRecords);
        const isRevision = (state.latestRevision.id !== null);
        let isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        let isViewer = CommonUtils.isViewer(this.props.currentUser);
        return <div ref={this.myRef}>
            <Paper className={classes.root} style={{ width: '1000px'}}>
                <Card className={classes.card}>
                    {(!state.isEditing ?
                            <CardHeader
                                action={
                                    <BlueButton
                                        variant="contained"
                                        color="secondary"
                                        startIcon={<AddCircleOutlineTwoTone/>}
                                        onClick={this.showModal}
                                        size="small"
                                        style={{marginRight: '10px'}}
                                        disabled={isAuditor || isViewer}
                                    >
                                        { t('common.add') }
                                    </BlueButton>
                                }
                                title={
                                    <span style={{color: "darkblue"}}>
                                        <p><b>{isRevision && `${t('context.common.revision')} ${state.latestRevision.number} ${t('context.common.author')}: ${state.latestRevision.author}`}</b></p>
                                        <p><b>{ t('context.common.approvedFor') }: {state.latestRevision.approvedBy} {t('context.common.on')} {moment(state.latestRevision.date).format('DD/MM/YYYY')}</b></p>
                                    </span>
                                }
                            />
                            :
                            <CardHeader
                                style={{ paddingBottom: "0px", paddingLeft: "46px" }}
                                title={
                                    <span style={{color: "darkblue"}}>
                                    <p><b>{state.header}</b></p>
                                </span>
                                }
                            />
                    )}
                    <CardContent>
                        {!isAuditor && !isViewer && <React.Fragment>
                <Typography variant="h6" style={{ paddingTop: '30px', paddingLeft: "30px" }}>
                    { t('operation.msds.addHeader') }
                 </Typography>
                 <div style={{ paddingLeft: "30px", paddingRight: "30px",  paddingBottom: "30px"}}>
                     <div>
                         <div style={{ paddingTop: "20px"}}>
                             <TextField
                                 id="title"
                                 name="title"
                                 value={state.title}
                                 label={ t('operation.msds.form.titleLabel') }
                                 onChange={this.onChange}
                                 style={{ width: "600px"}}
                             />
                         </div>
                         <MuiPickersUtilsProvider utils={MomentUtils}>
                             <KeyboardDatePicker
                                 disableToolbar
                                 autoOk
                                 variant="inline"
                                 format="DD/MM/YYYY"
                                 margin="normal"
                                 id="expiryDate"
                                 label={ t('operation.msds.form.dateLabel') }
                                 name="expiryDate"
                                 value={state.expiryDate}
                                 onChange={ this.onDateChange }
                                 KeyboardButtonProps={{ 'aria-label': 'change date' }}
                                 style={{ width: "300px"}}
                             />
                         </MuiPickersUtilsProvider>
                     </div>
                     <div className="form-group files" style={{ paddingTop: "20px"}}>
                        <Typography>{ t('operation.msds.attachPrompt') }</Typography>
                         {(state.fileName && state.fileName !== '') &&
                             <aside>
                                 <h4>{ t('common.previouslyUploaded') }</h4> { state.fileName } <GreyButton onClick={() => downloadFile(state.fileId)}>{ t('common.download') }</GreyButton>
                             </aside>
                         }
                         <TextField
                             variant="outlined"
                             margin="normal"
                             required
                             fullWidth
                             id="file"
                             name="file"
                             autoFocus
                             onChange={ this.onFileSelect }
                             type="file"
                         />
                     </div>
                     <OrangeButton
                         variant="contained"
                         color="secondary"
                         startIcon={<HighlightOffTwoTone />}
                         size="small"
                         onClick={this.onClear}
                         style={{ marginTop: '20px', marginBottom: '20px', marginRight: '20px', float: "left" }}
                     >
                        { t('common.clearForm') }
                     </OrangeButton>
                     <GreenButton
                         variant="contained"
                         color="secondary"
                         startIcon={<AddCircleTwoTone />}
                         size="small"
                         onClick={this.onSave}
                         style={{ marginTop: '20px', marginBottom: '20px', float: "left" }}
                     >
                        { t('common.save') }
                     </GreenButton>
                 </div></React.Fragment>}
                {!isDemo && !isViewer && <GreenButton startIcon={<SystemUpdateAltTwoTone/>} onClick={this.export} style={{ float: 'right' }}>{ t('common.export') }</GreenButton>}
                 <div style={{ paddingTop: '60px', paddingLeft: "30px", paddingRight: '30px', width: '1000px' }}>
                     <Typography component="h2" variant="h5">
                        { t('operation.msds.pageTitle') }
                     </Typography>
                     <TableComponent
                         tableKey="msds"
                         data={state.msdsRecords}
                         columns={columns}
                         handleSubmit={this.handleSubmit}
                         handleAddRow={this.handleAddRow}
                         handleRowDel={this.onDelete}
                         handleRowEdit={this.onEdit}
                         pagination={true}
                         allowUpdateDelete={(isAuditor || isViewer) ? 'no' : 'yes'}
                     />
                 </div>
                 </CardContent>
                 </Card>
                 <Modal
                     aria-labelledby="simple-modal-title"
                     aria-describedby="simple-modal-description"
                     open={state.show}
                     onClose={() => this.closeModal(null)}
                 >
                     <CommonRevisionModal latestRevisionDto={state.latestRevision} addRevision={this.addRevision}/>
                 </Modal>
             </Paper>
             <NotificationContainer/>
         </div>;
     }
 }

 export default withStyles(classes)(Msds);
